import React from "react";
import Marquee from "react-fast-marquee";
import { Check, ArrowUpRight } from "lucide-react";
import { useConsultation } from "../context/ConsultationContext";

const BANKS = [
  "EMIRATES NBD",
  "WIO",
  "MASHREQ",
  "FAB",
  "RAKBANK",
  "ADCB",
  "CBD",
  "HSBC UAE",
];

const POINTS = [
  "Pre-approval readiness checks to save weeks of back-and-forth",
  "Document attestation, UBO and KYC preparation — audit-grade",
  "Direct introductions to relationship managers at tier-1 banks",
];

export default function BankingSection() {
  const { open } = useConsultation();

  return (
    <section
      data-testid="banking-section"
      className="relative bg-white py-20 md:py-32 overflow-hidden"
    >
      {/* Editorial marquee band */}
      <div className="bg-[#EEF2FF] border-y border-[#3366FF]/30 py-6 md:py-8 -mt-4 md:-mt-8 mb-16 md:mb-24">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {BANKS.concat(BANKS).map((bank, i) => (
            <span
              key={`${bank}-${i}`}
              className="font-heading text-2xl md:text-4xl font-black tracking-tight text-[#002366] mx-8 md:mx-14 whitespace-nowrap flex items-center gap-8 md:gap-14"
            >
              {bank}
              <span className="w-1.5 h-1.5 rounded-full bg-[#3366FF]" />
            </span>
          ))}
        </Marquee>
      </div>

      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <p className="overline text-[#002366]/70">Corporate Banking</p>
            <div className="gold-rule mt-5 mb-6" />
            <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Bridging the gap to{" "}
              <span className="font-black text-[#002366]">global banking</span>.
            </h2>
            <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed">
              Opening a corporate account in the UAE is often the final — and most
              difficult — hurdle. StartINC leverages deep relationships with leading
              local and international banks to ensure your application is structured for
              approval, not rejection.
            </p>
          </div>

          <div className="lg:col-span-6 lg:pl-8 lg:border-l border-slate-200">
            <ul className="space-y-5">
              {POINTS.map((p, i) => (
                <li key={p} className="flex gap-4" data-testid={`banking-point-${i}`}>
                  <div className="shrink-0 w-9 h-9 rounded-sm bg-[#002366] text-[#3366FF] flex items-center justify-center">
                    <Check className="w-4 h-4" />
                  </div>
                  <p className="text-slate-700 leading-relaxed pt-1">{p}</p>
                </li>
              ))}
            </ul>

            <button
              data-testid="banking-cta-button"
              onClick={() => open("banking")}
              className="mt-10 btn-navy"
            >
              Open a corporate account <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
